import { formatValue } from '../utils/formatValue';
import { dictionaryTableQuantitatives } from '../dictionary/dictionaryTableQuantitatives';

export function factoryTableQuantitatives(data: any) {
  let count = 1;

  const result = {};

  data.quantitativos.forEach((quantitativo) => {
    const categoriaDic = dictionaryTableQuantitatives[quantitativo.categoria];

    if (categoriaDic) {
      categoriaDic.quant = quantitativo.itens.map((item) => {
        const auxDic = {};
        Object.entries(categoriaDic.quant[0]).forEach(([key, propriedadeDic]: [string, any]) => {
          if (key === 'item') {
            auxDic[key] = {
              label: propriedadeDic.label,
              value: String(count).padStart(4, '0'),
              typeValue: propriedadeDic.typeValue || '',
              fractionDigits: propriedadeDic.fractionDigits || 0,
            };
            count += 1;
          } else if (item[key] !== undefined) {
            auxDic[key] = {
              label: propriedadeDic.label,
              value: formatValue(item[key], propriedadeDic.fractionDigits) || '-',
              typeValue: propriedadeDic.typeValue || '',
              fractionDigits: propriedadeDic.fractionDigits || 0,
            };
          }
        });

        return auxDic;
      });

      if (categoriaDic.totais) {
        const auxTotal = {};
        Object.entries(categoriaDic.totais[0]).forEach(([key, propriedadeDic]: [string, any]) => {
          if (quantitativo[key] !== undefined) {
            auxTotal[key] = {
              label: propriedadeDic.label,
              value: formatValue(quantitativo[key], propriedadeDic.fractionDigits),
              typeValue: propriedadeDic.typeValue || '',
              fractionDigits: propriedadeDic.fractionDigits || 0,
            };
          }
        });

        categoriaDic.totais = [auxTotal];
      }
      result[quantitativo.categoria] = categoriaDic;
    }
  });

  result.area = data.area_total;

  return result;
}
